import type { InstallmentDetail } from '../../../../hooks/use-reports';

/** Qué dice el chip de estado de una cuota. El ESTADO lo calcula el servidor con
 *  el «hoy» del seminario (`installmentState`, la misma regla del resumen del
 *  alumno); aquí no se recalcula con el reloj del navegador. Una cuota vencida
 *  con pagos parciales dice «Vencida · pagado X de Y». */
export function installmentChip(inst: InstallmentDetail): {
  status: InstallmentDetail['status'];
  key: 'statusPaid' | 'statusOverdue' | 'statusOverduePaid' | 'statusPartial' | 'statusPending';
  paid: number;
  amount: number;
} {
  const base = { status: inst.status, paid: inst.allocatedAmount, amount: inst.amount };
  switch (inst.status) {
    case 'paid':
      return { ...base, key: 'statusPaid' };
    case 'overdue':
      return { ...base, key: inst.allocatedAmount > 0 ? 'statusOverduePaid' : 'statusOverdue' };
    case 'partial':
      return { ...base, key: 'statusPartial' };
    default:
      return { ...base, key: 'statusPending' };
  }
}
